var map = {
	"./_settings.scss": 1920,
	"./base/_alert-boxes.scss": 1921,
	"./base/_badges.scss": 1922,
	"./base/_base.scss": 1923,
	"./base/_cw-footer.scss": 1924,
	"./base/_fonts.scss": 1925,
	"./base/_forms.scss": 1926,
	"./base/_grid.scss": 1927,
	"./base/_layout.scss": 1928,
	"./base/_lightbox.scss": 1929,
	"./base/_modal.scss": 1930,
	"./base/_nav-bar.scss": 1931,
	"./base/_normal_font.scss": 510,
	"./base/_offcanvas.scss": 1932,
	"./base/_pagination.scss": 1933,
	"./base/_panels.scss": 1934,
	"./base/_sharing.scss": 1935,
	"./base/_switches.scss": 1936,
	"./base/_tables.scss": 1937,
	"./base/_tooltips.scss": 1938,
	"./base/_type.scss": 1939,
	"./base/_video.scss": 1940,
	"./base/_visibility.scss": 1941,
	"./base/buttons/_all.scss": 1942,
	"./base/buttons/_mixins.scss": 1943,
	"./base/buttons/_sharing.scss": 1944,
	"./base/forms/_checkboxes.scss": 1945,
	"./base/forms/_input-combos.scss": 1946,
	"./base/forms/_non-text.scss": 1947,
	"./base/forms/_text-fields.scss": 1948,
	"./base/nav-bar/_base-with-links.scss": 1949,
	"./base/nav-bar/_base.scss": 1950,
	"./base/nav-bar/_fade.scss": 1951,
	"./base/nav-bar/_inverted.scss": 1952,
	"./base/nav-bar/_large-up.scss": 1953,
	"./components/_hero.scss": 1954,
	"./pages/accounts.scss": 1955,
	"./pages/admin.scss": 1956,
	"./pages/admin/grants.scss": 1957,
	"./pages/admin/offline_donations.scss": 1958,
	"./pages/authorization.scss": 1959,
	"./pages/birthdays.scss": 1960,
	"./pages/campaigns.scss": 1961,
	"./pages/donations.scss": 1962,
	"./pages/donations/_donate-form.scss": 1963,
	"./pages/donations/_hidden-campaign.scss": 1964,
	"./pages/donations/_sponsor-recognition.scss": 1965,
	"./pages/donations/_thank-you.scss": 1966,
	"./pages/donations/components/_ach-popout-form.scss": 1967,
	"./pages/donations/components/_apple-pay-button.scss": 1968,
	"./pages/donations/components/_browser-fallback.scss": 1969,
	"./pages/donations/components/_donate-buttons.scss": 1970,
	"./pages/donations/components/_donate-by-check-modal.scss": 1971,
	"./pages/donations/components/_donation-form-inputs.scss": 1972,
	"./pages/donations/components/_gift_aid.scss": 1973,
	"./pages/donations/components/_iho.scss": 1974,
	"./pages/donations/components/_offscreen-donate-components.scss": 1975,
	"./pages/donations/components/_stripe-elements.scss": 1976,
	"./pages/donations/dynamic.scss": 1977,
	"./pages/donations/general.scss": 1978,
	"./pages/donations/gift-the-spring.scss": 1979,
	"./pages/donations/in-honor-of.scss": 1980,
	"./pages/donations/sponsor.scss": 1981,
	"./pages/donations/the-spring-new.scss": 1982,
	"./pages/donations/thespring.scss": 1983,
	"./pages/edit_mailing_list_subscriber.scss": 1984,
	"./pages/exceptions.scss": 1985,
	"./pages/founders.scss": 1986,
	"./pages/mailing-list-subscribers.scss": 1987,
	"./pages/partners.scss": 1988,
	"./pages/premium_impact_profile.scss": 1989,
	"./pages/profile/bps_membership.scss": 1990,
	"./pages/profile/lifetime_impact.scss": 1991,
	"./pages/profile/my_projects.scss": 1992,
	"./pages/profile/shared.scss": 1993,
	"./pages/profile/spring_membership.scss": 1994,
	"./pages/profile/user_private.scss": 1995,
	"./pages/profile/user_public.scss": 1996,
	"./pages/projects/_country_icons.scss": 1997,
	"./pages/projects/projects.scss": 1998,
	"./pages/redeem-the-spring.scss": 1999,
	"./pages/search.scss": 2000,
	"./pages/static_pages/about.scss": 2001,
	"./pages/static_pages/brand_partnerships.scss": 2002,
	"./pages/static_pages/company_match.scss": 2003,
	"./pages/static_pages/company_match_iframe.scss": 2004,
	"./pages/static_pages/completed_projects.scss": 2005,
	"./pages/static_pages/css_docs.scss": 2006,
	"./pages/static_pages/education.scss": 2007,
	"./pages/static_pages/error.scss": 2008,
	"./pages/static_pages/financials.scss": 2009,
	"./pages/static_pages/fundraise.scss": 2010,
	"./pages/static_pages/gala_dashboard.scss": 2011,
	"./pages/static_pages/home.scss": 2012,
	"./pages/static_pages/hundred_percent_model.scss": 2013,
	"./pages/static_pages/in_kind_donations.scss": 2014,
	"./pages/static_pages/internships.scss": 2015,
	"./pages/static_pages/jobs.scss": 2016,
	"./pages/static_pages/kids.scss": 2017,
	"./pages/static_pages/local_partners.scss": 2018,
	"./pages/static_pages/media.scss": 2019,
	"./pages/static_pages/mission.scss": 2020,
	"./pages/static_pages/our_approach.scss": 2021,
	"./pages/static_pages/our_projects.scss": 2022,
	"./pages/static_pages/our_work.scss": 2023,
	"./pages/static_pages/privacy.scss": 2024,
	"./pages/static_pages/scott_harrison_story.scss": 2025,
	"./pages/static_pages/scotts_story.scss": 2026,
	"./pages/static_pages/sensors.scss": 2027,
	"./pages/static_pages/staff.scss": 2028,
	"./pages/static_pages/the_pool.scss": 2029,
	"./pages/static_pages/volunteer.scss": 2030,
	"./pages/static_pages/water_crisis_learn.scss": 2031,
	"./pages/static_pages/whywater.scss": 2032,
	"./pages/stories.scss": 2033,
	"./pages/subscriptions.scss": 2034,
	"./pages/the_spring_series.scss": 2035,
	"./pages/thirst/thirst.scss": 2036,
	"./pages/uk/about.scss": 2037,
	"./pages/uk/partnerships.scss": 2038,
	"./pages/uk/privacy.scss": 2039,
	"./pages/uk/uk.scss": 2040,
	"./pages/unpledge.scss": 2041,
	"./pages/video_landing_page.scss": 2042,
	"./pages/wwd/community.scss": 2043,
	"./pages/wwd/discover.scss": 2044,
	"./pages/wwd/explore.scss": 2045,
	"./pages/wwd/profile.scss": 2046,
	"./pages/wwd/shared.scss": 2047,
	"./pages/wwd/welcome.scss": 2048,
	"./patterns/action-tiles.scss": 2049,
	"./patterns/avatar-initial.scss": 2050,
	"./patterns/cards.scss": 2051,
	"./patterns/cw-icon-spin.scss": 2052,
	"./patterns/dashed-elements.scss": 2053,
	"./patterns/full-bottom-bg.scss": 2054,
	"./patterns/image-fill.scss": 2055,
	"./patterns/leading-image-block.scss": 2056,
	"./patterns/module.scss": 2057,
	"./patterns/progress.scss": 2058,
	"./patterns/side-by-side.scss": 2059,
	"./patterns/split-bg-block.scss": 2060,
	"./patterns/tabs.scss": 2061,
	"./patterns/text-separator.scss": 2062,
	"./patterns/yellow-underlined.scss": 2063,
	"./react-components/completed-projects-map.scss": 2064,
	"./react-components/email-capture-modal.scss": 2065,
	"./react-components/journey-player.scss": 2066,
	"./react-components/mailing-list-intercept-modal.scss": 2067,
	"./react-components/people-served-input.scss": 2068,
	"./settings/_colors.scss": 2069,
	"./settings/_general.scss": 2070,
	"./settings/_media-queries.scss": 2071,
	"./settings/_mixins.scss": 2072,
	"./settings/_type.scss": 2073,
	"./shared/breadcrumbs.scss": 2074,
	"./shared/clipboard-button.scss": 2075,
	"./shared/comments.scss": 2076,
	"./shared/cookie_banner.scss": 2077,
	"./shared/datepicker.scss": 2078,
	"./shared/fixed-banner.scss": 2079,
	"./shared/geosuggest.scss": 2080,
	"./shared/grecaptcha.scss": 2081,
	"./shared/hide-donate-links.scss": 2082,
	"./shared/intl-tel-input.scss": 2083,
	"./shared/mailing-list-form.scss": 2084,
	"./shared/mailing-list-sign-up-button.scss": 2085,
	"./shared/mobile-donate-banner.scss": 2086,
	"./shared/parsley.scss": 2087,
	"./shared/percy.scss": 2088,
	"./shared/public_campaign_card_details.scss": 2089,
	"./shared/simple-form.scss": 2090,
	"./shared/sly-quiz.scss": 2091,
	"./shared/spring_logo_svg.scss": 2092,
	"./shared/spring_mark_svg.scss": 2093,
	"./shared/spring_series_seasons.scss": 2094,
	"./shared/video-box-container.scss": 2095,
	"./tailwinds.scss": 666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1919;